/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useRef } from 'react';
import { Drawer, Tabs, Input, Form, Button, Select, Space } from 'antd';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 }
  }
};

const DashboardLevelConfig = () => {
  const [visible] = useState(false);
  const [dropdownObject, setDropdownObject] = useState({});
  const dashRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    dashRef.current
      .validateFields()
      .then(async (values) => {
        setDropdownObject(prevState => ({
          ...prevState,
          [values.key]: { ...values }
        }));
      })
      .catch(() => {});
  };

  // const hasErrors = (fieldsError) => {
  //   return Object.keys(fieldsError).some((field) => fieldsError[field]);
  // };

  const items = [
    {
      key: '1',
      label: 'Multi Dropdown',
      children: (
        <div>
          <Form ref={dashRef} layout="vertical" onSubmit={handleSubmit}>
            <Form.Item
              name="name"
              rules={[{ required: true, message: 'Please input your Name!' }]}
            >
              <Input placeholder="Name" />
            </Form.Item>
            <Form.Item 
              name="key" 
              rules={[{ required: true, message: 'Please input your key!' }]}
            >
              <Input placeholder="Key" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Add
              </Button>
            </Form.Item>
          </Form>
          {Object.keys(dropdownObject).length > 0 && 
            Object.keys(dropdownObject).map((dropdownName, index) => (
              <div key={index}>
                {dropdownObject[dropdownName].name}
                <Form {...formItemLayout}>
                  <Form.Item label={'Show Dropdown'}>
                    <Input placeholder="dropdown" width="300" />
                  </Form.Item>
                  <Form.Item label={'Place holder'}>
                    <Input placeholder="Placeholder" width="300" />
                  </Form.Item>
                  <Form.Item label={'Request Input'}>
                    <Select 
                      placeholder="Select Input Type" 
                      style={{ width: '300' }}
                    >
                      <Option value="array">Array</Option>
                      <Option value="object">Object</Option>
                      <Option value="string">String</Option>
                    </Select>
                  </Form.Item>
                </Form>
              </div>
            ))
          }
        </div>
      )
    }
  ];

  return (
    <Drawer
      width={700}
      title="Dashboard Header Configuration"
      open={visible}
      closable
      extra={
        <Space>
          <Button type="primary" onClick={handleSubmit}>
            OK
          </Button>
        </Space>
      }
    >
      <Tabs style={{ color: 'white' }} items={items} />
    </Drawer>
  );
};

export default DashboardLevelConfig;
